import { render, staticRenderFns } from "./BlogPostsSubscribe.vue?vue&type=template&id=2271a75c&scoped=true&"
import script from "./BlogPostsSubscribe.vue?vue&type=script&lang=js&"
export * from "./BlogPostsSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsSubscribe.vue?vue&type=style&index=0&id=2271a75c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271a75c",
  null
  
)

export default component.exports